import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useContractsContext } from '@/modules/workforce/Contracts/context';
import Search from '@/shared/components/atoms/Search';
import Tabs from '@/shared/components/atoms/Tabs';

export const TAB_QUERY_INDICATOR = 'contract-type';

function FiltersTabs() {
  const { t } = useTranslation('common');
  const {
    setKeyword,
    // state: { keyword },
  } = useContractsContext();

  const getTabsList = (t: TFunction) => [
    {
      label: t('current'),
      value: '1',
    },
    {
      label: t('upcoming'),
      value: '2',
    },
    {
      label: t('past'),
      value: '3',
    },
  ];

  return (
    <div className='flex w-full items-center justify-between gap-2'>
      <Tabs
        getLabel={(item) => item?.label}
        getValue={(item) => item?.value}
        tabsList={getTabsList(t)}
        variant='connected'
        defaultValue='1'
        tabQueryIndicator={TAB_QUERY_INDICATOR}
      />
      <div className='flex items-center gap-16'>
        <Search onSearch={(keyword) => setKeyword(keyword)} />
        {/* <Button
          type='button'
          variant='text'
          className='border-xs border-outline-default'
          onClick={
            () => {
              //
            }
            // openModal(
            //   <AdvancedFilter state={state} dispatch={dispatch} />,
            //   <div className='flex items-center gap-2'>
            //     <div className='flex h-40 w-40 items-center justify-center rounded-full bg-primary-95'>
            //       <span className='text-primary-default'>
            //         <Filters width='24' height='24' />
            //       </span>
            //     </div>
            //     <Typography weight='semiBold' variant='h3'>
            //       {t('filters')}
            //     </Typography>
            //   </div>,
            //   undefined,
            //   'sidebar',
            //   'w-auto !px-16'
            // )
          }
        >
          <div className='flex w-full items-center justify-center gap-2'>
            <Filters />
            <span className='text-base font-semi-bold text-primary-default'>
              {t('filters')}
            </span>
          </div>
        </Button> */}
      </div>
    </div>
  );
}

export { FiltersTabs };
